import { Text, Box } from '@usap/uicomponents'
import styled from 'styled-components'

const dividerColor = props => props.theme.global.colors['border-2'];
const tabletBreakpoints = props => props.theme.mediaQuery.up('tablet-landscape');

export const TextWithStyle = styled(Text)`
  cursor: ${({ noPointer = false }) => (noPointer ? 'unset' : 'pointer')};
`

export const Divider = styled(Text)`
  font-size: 14px;
  line-height: 20px;
  color: ${dividerColor};
  padding: 0 4px;
`

export const BreadcrumbsContainer = styled(Box)`
  box-sizing: border-box;
  width: 100%;
  margin: 24px auto;
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  &.breadCrumbListScrollable {
    overflow-x: scroll;
    white-space: nowrap;
    display: inline-block;
  }
  
  &.breadCrumbListScrollable li {
    display: inline-block;
  }
  
  &.breadCrumbListScrollable::-webkit-scrollbar {
    display: none;
  }

  ${tabletBreakpoints} {
    margin: 24px auto 32px;
  }
`